import Api from './Api';

const END_POINT = 'honorario-detalle';
const END_POINT_NEW = 'honorario-cierra';
const END_POINT_BONO = 'honorario-bono';
const END_POINT_DES = 'honorario-descuento';
const END_POINT_ABRE = 'honorario-abre';

export default {
    async getEmpleados (id){
        return await Api.get(`${END_POINT}/${id}`);
    },
    async actualizaEmpleado(descuento) {
        return await Api.patch(`${END_POINT}/${descuento.id}`, descuento)
    },
    async actualizaDescuento(descuento) {
        return await Api.patch(`${END_POINT_DES}/${descuento.id}`, descuento)
    },
    async calculaCierra(items) {
        return await Api.post(`${END_POINT_NEW}`, items);
    },
    async actualizaBono(bono){
        return await Api.patch(`${END_POINT_BONO}/${bono.id}`, bono)
    },
    async reabrirHonorario(items) {
        return await Api.post(`${END_POINT_ABRE}`, items);
    },
    async reciboDownload(id) {
        return await Api.get('recibo/download/'+`${id}`);
    },
    async actualizarReciboHonorario(id_recibo_honorario){
        return await Api.get('reciboHonorario/actualizar/' + `${id_recibo_honorario}`);
    }
}